import { render, staticRenderFns } from "./template.vue?vue&type=template&id=498eeb58&scoped=true&"
import script from "./template.js?vue&type=script&lang=js&"
export * from "./template.js?vue&type=script&lang=js&"
import style0 from "./template.vue?vue&type=style&index=0&id=498eeb58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498eeb58",
  null
  
)

export default component.exports